import React from 'react';
import { PRODUCT } from '../../data/content';
type Book3DProps = {
  className?: string;
  spineWidth?: number;
  angle?: number;
};
export function Book3D({
  className = '',
  spineWidth = 26,
  angle = -17
}: Book3DProps) {
  return <div className={`relative ${className}`} style={{
    perspective: '2000px'
  }} data-id="element-171" data-mp="3ssscugkvia5t">
      <div className="relative" style={{
      transformStyle: 'preserve-3d',
      transform: `rotateY(${angle}deg) rotateX(2deg)`
    }} data-id="element-172" data-mp="1gh7bs32vcw7">
        {/* Lomo */}
        <div aria-hidden="true" className="absolute top-[1.5%] h-[97%] bg-[#122733]" style={{
        width: `${spineWidth}px`,
        left: `-${spineWidth}px`,
        transformOrigin: 'right center',
        transform: 'rotateY(90deg)',
        borderRadius: '3px 0 0 3px'
      }} data-id="element-173" data-mp="ag3yzm6094c2">
          <div className="h-full w-full border-r border-white/10 bg-[linear-gradient(to_right,rgba(255,255,255,0.14),rgba(0,0,0,0.35))]" data-id="element-174" data-mp="2h6tn8lzmy15y" />
        </div>

        <img src={PRODUCT.coverImage} alt="Portada de la guía Europa por Primera Vez" className="relative block w-full rounded-[2px] rounded-r-[6px] shadow-[0_40px_60px_-30px_rgba(27,51,64,0.55)]" data-id="element-175" data-mp="2m6ps0ng5pwmk" />

        {/* Brillo de tapa y canto de páginas */}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 rounded-[2px] rounded-r-[6px]" style={{
        background: 'linear-gradient(100deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0) 18%, rgba(255,255,255,0) 82%, rgba(255,255,255,0.12) 100%)'
      }} data-id="element-176" data-mp="3u64leejpdiuq" />
        <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-[10px] bg-[linear-gradient(to_right,rgba(0,0,0,0.28),rgba(0,0,0,0))]" data-id="element-177" data-mp="qn1ubdn2gfbr" />
        <div aria-hidden="true" className="pointer-events-none absolute inset-y-[1.5%] -right-[3px] w-[4px] rounded-r-[3px] bg-[repeating-linear-gradient(to_bottom,#f6f2e8_0px,#f6f2e8_2px,#ddd6c6_3px)]" data-id="element-178" data-mp="hnepsiz1iteh" />
      </div>

      <div aria-hidden="true" className="mx-auto mt-6 h-6 w-[78%] rounded-[50%] bg-oceano/12 blur-[10px]" data-id="element-179" data-mp="32g9u4ccabj3f" />
    </div>;
}